import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight, Trophy } from "@phosphor-icons/react";

export default function Quizzes() {
  const [items, setItems] = useState([]);
  const [progress, setProgress] = useState({ quiz_best: [] });

  useEffect(() => {
    api.get("/quizzes").then((r) => setItems(r.data));
    api.get("/progress/mine").then((r) => setProgress(r.data));
  }, []);

  const bestFor = (id) => progress.quiz_best.find((q) => q.quiz_id === id);

  return (
    <div className="space-y-10">
      <header className="fade-up">
        <div className="overline mb-3">Interactive Quizzes</div>
        <h1 className="font-display text-5xl lg:text-6xl tracking-tighter leading-[0.95]">Score. Review. Remember.</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl">Timed-style quizzes based on real interview traps. Explanations after every question.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-border">
        {items.map((q) => {
          const best = bestFor(q.id);
          return (
            <Link key={q.id} to={`/app/quizzes/${q.id}`} data-testid={`quiz-card-${q.id}`}
              className="p-8 bg-white border-r border-b border-border hover:bg-secondary transition-colors group flex flex-col">
              <div className="overline">{q.num_questions} questions</div>
              <div className="font-display text-3xl mt-3 leading-tight">{q.title}</div>
              <p className="text-sm text-muted-foreground mt-3 flex-1">{q.description}</p>
              {best && (
                <div className="mt-4 flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-primary">
                  <Trophy size={14} weight="fill" /> Best · {best.percent}%
                </div>
              )}
              <div className="mt-6 flex items-center gap-2 text-sm font-medium text-primary">
                Start <ArrowRight size={14} weight="bold" className="group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
